export const twCellPhonePattern = /^(09)[0-9]{8}$/g
export const digitPattern = /\D/g
export const timeDurationPattern = /(\d+)?：([0-5]?[0-9])?：([0-5]?[0-9])?/
export const noSpecialCharacter = /^[\u4e00-\u9fa5a-zA-Z0-9]{1,50}$/
